/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SkillsControllerFindAllQueryResponse, SkillsControllerFindAllQueryParams, SkillsControllerFindAll401, SkillsControllerFindAll403 } from "../../models/skillsController/SkillsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { skillsControllerFindAll } from "../../clients/skillsService/skillsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const skillsControllerFindAllQueryKey = (params: SkillsControllerFindAllQueryParams) => [{
  url: '/api/v1/skills'
}, ...(params ? [params] : [])] as const;
export type SkillsControllerFindAllQueryKey = ReturnType<typeof skillsControllerFindAllQueryKey>;
export function skillsControllerFindAllQueryOptions(params: SkillsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = skillsControllerFindAllQueryKey(params);
  return queryOptions<SkillsControllerFindAllQueryResponse, ResponseErrorConfig<SkillsControllerFindAll401 | SkillsControllerFindAll403>, SkillsControllerFindAllQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return skillsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get visible skills for the current context
 * {@link /api/v1/skills}
 */
export function useSkillsControllerFindAll<TData = SkillsControllerFindAllQueryResponse, TQueryData = SkillsControllerFindAllQueryResponse, TQueryKey extends QueryKey = SkillsControllerFindAllQueryKey>(params: SkillsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<SkillsControllerFindAllQueryResponse, ResponseErrorConfig<SkillsControllerFindAll401 | SkillsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? skillsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...skillsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SkillsControllerFindAll401 | SkillsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}